import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { SxErrorService } from 'app/services/sx-error.service';
import { FormCategoryInformation } from '@model';

@Injectable()
export class FormsService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getFormCategoriesWithInfo(): Observable<FormCategoryInformation> {
    return this.http
      .get<FormCategoryInformation>(`${environment.apiEndpoint}/forms/WithInformation`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
